import { Component, Input, OnInit } from '@angular/core';
import { Resident } from '../../models/resident.model';
import { DeactivationReason } from '../../../core/types/enums';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PartnerCopyNamePipe } from '../../pipes/partner-copy-name.pipe';

@Component({
  selector: 'app-inactive-resident-message',
  templateUrl: './inactive-resident-message.component.html',
  styleUrls: ['./inactive-resident-message.component.scss'],
  imports: [CommonModule, PartnerCopyNamePipe],
})
export class InactiveResidentMessageComponent {
  @Input() resident: Resident;
  @Input() closeDialog: () => void;
  DeactivationReason = DeactivationReason;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  goToPage(fname: string, lname: string): void {
    if (this.closeDialog) {
      this.closeDialog();
    }
    const params = this.route.snapshot.queryParams;
    this.router.navigate(['/order-history'], {
      queryParams: {
        customerId: params.customerId,
        departmentId: null,
        resident: fname && lname ? `${fname} ${lname}` : null,
      },
    });
  }
}
